import { ReactNode } from "react";
import { styled } from "@stitches/react";
import { Button } from "@/vendor/Forge/dist";
import FilterIcon from "@/components/Icons/filter";
import { SortOrder } from "@/types/order-table";
import SortIcon from "./sort-icon";

const Wrapper = styled("div", {
  display: "flex",
  alignItems: "center",
});

const CountWrapper = styled("div", {
  color: "#f3a81c !important",
  fontSize: "18px !important",
  fontWeight: "bold !important",
});

interface Props {
  id: string;
  name: ReactNode;
  sortOrder?: SortOrder;
  onSortClick?: () => void;
  onFilterClick?: () => void;
  isActiveFilter?: boolean;
  activeFilterCount?: number;
}

const ColumnHeader = ({
  id,
  name,
  sortOrder = null,
  onSortClick,
  onFilterClick,
  isActiveFilter = false,
  activeFilterCount,
}: Props) => {
  return (
    <Wrapper>
      {name}
      {onSortClick && (
        <SortIcon sortOrder={sortOrder} onIconClick={onSortClick} />
      )}
      {onFilterClick && (
        <Button data-testid={id} variant="tertiary" onClick={onFilterClick}>
          <FilterIcon active={isActiveFilter} />{" "}
          {isActiveFilter && <CountWrapper>{activeFilterCount}</CountWrapper>}
        </Button>
      )}
    </Wrapper>
  );
};

export default ColumnHeader;
